var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{attrs:{"id":"app"}},[_c('app-head'),_c('app-nav'),_c('router-view',{staticClass:"main-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }